import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FormatDate } from 'src/components/atoms/format-date';
import { Status } from 'src/components/atoms/status';
import { UserRole } from 'src/types/enum/user-role';
import { dateFormats } from 'src/utils/date-formats';
import {
  adminInvitationStateColor,
  adminInvitationStateTranslations,
} from '../../constants/admin-inviation-status';
import {
  adminsRolesColor,
  adminsRoleTranslations,
} from '../../constants/admins-roles';
import { AdminInvitationStatus } from '../../types/enum/admin-invitation-status';
import { AdminToManage } from '../../types/payloads/admin-to-manage';

interface Props {
  token: string;
  email: string;
  phoneNumber: string;
  role: UserRole;
  invitedAt: number;
  status: AdminInvitationStatus;
  actionsSlot: (payload: AdminToManage) => ReactNode;
}

export const AdminsTableRow = ({
  token,
  email,
  phoneNumber,
  role,
  invitedAt,
  status,
  actionsSlot,
}: Props) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>
        <Typography color="text.primary" variant="inherit">
          {email}
        </Typography>
      </TableCell>
      <TableCell>
        {phoneNumber ? (
          <Typography color="text.primary" variant="inherit">
            {phoneNumber}
          </Typography>
        ) : (
          <Typography color="text.secondary" variant="inherit">
            N/A
          </Typography>
        )}
      </TableCell>
      <TableCell>
        <Status
          label={t(adminsRoleTranslations[role])}
          color={adminsRolesColor[role]}
        />
      </TableCell>
      <TableCell>
        <Box>
          <Typography color="inherit" variant="inherit">
            <FormatDate
              date={new Date(invitedAt)}
              format={`${dateFormats.day} ${dateFormats.monthShort} ${dateFormats.yearShort}`}
            />
          </Typography>

          <Typography color="text.secondary" variant="inherit">
            <FormatDate
              date={new Date(invitedAt)}
              format={`${dateFormats.hours}:${dateFormats.minutes}`}
            />
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Status
          label={t(
            adminInvitationStateTranslations[
              status ?? AdminInvitationStatus.PENDING
            ],
          )}
          color={
            adminInvitationStateColor[status ?? AdminInvitationStatus.PENDING]
          }
        />
      </TableCell>
      <TableCell align="right">
        {actionsSlot({
          token,
          email,
          phoneNumber,
          role,
          status,
        })}
      </TableCell>
    </TableRow>
  );
};
